const OprHistory = () =>
  import('@/views/main/helper/oprHistory/OprHistory.vue')
export default {
  path: '/main/helper/oprHistory',
  name: 'OprHistory',
  component: OprHistory,
  children: []
}
